<template>
  <div style="display: flex; align-items: flex-start;">
    <sidebar style="margin-right: 20px; max-width: 200px" />
    <el-card style="width: 100%">
      <div
          slot="header"
          class="clearfix"
      >
        <span>Bizonylat beérkeztetések - szállítólevelek</span>
        <div class="" style="float: right">
          <el-button
              style="margin-top: -5px;"
              type="success"
              size="small"
              @click="$router.replace('/representative-processes/receipt-receives/delivery/add')"
              icon="el-icon-plus"
              v-can="'receiptreceives.create'"
          >
            Új beérkeztetés
          </el-button>
        </div>
      </div>
      <div v-loading="loading" style="min-height: 81px;">
        <table-filter
            v-if="filterConfig"
            :config="filterConfig"
            action="deliveryReceiptReceives/fetchAll"
        />
      </div>

      <delivery-receipt-receives-list />

      <template v-if="$route.meta.showAddDeliveryReceiptReceiveDialog">
        <delivery-receipt-receive-dialog
        />
      </template>

    </el-card>
  </div>

</template>

<script>
  import DeliveryReceiptReceivesList from '../../../components/representativeProcesses/receiptReceives/delivery/List';
  import DeliveryReceiptReceiveDialog from '../../../components/representativeProcesses/receiptReceives/delivery/Dialog'
  import TableFilter from '../../../components/TableFilter';
  import Sidebar from "../../../components/representativeProcesses/receiptReceives/Sidebar";

  export default {
    components: {
      Sidebar,
      DeliveryReceiptReceivesList,
      DeliveryReceiptReceiveDialog,
      TableFilter,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        let users = this.$store.getters['user/users'];
        if (!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }

        this.filterConfig = [
          {
            type: 'text',
            name: 'receipt_number',
            label: 'Bizonylatszám',
            defaultSearch: true,
          },
          {
            type: 'multipleSelect',
            options: users,
            name: 'representativeUser',
            label: 'Képviselő',
            labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
            valueKey: 'id',
          },
          {
            type: 'dateRange',
            name: 'daterange',
            label: 'Időszak',
          },
        ];
      },
    },
  };
</script>
